export function masterCarrierLabel(item: Dict, locale: string): string {
  const master = item.extend?.master
  return (
    (locale === 'zh-CN' ? master?.name : master?.nameEn) || String(item.value)
  )
}

export function masterCarrierOptions(
  items: Dict[] = [],
  locale: string,
): Dict[] {
  return items
    .filter((item) => item.extend?.master?.enabled === true)
    .map((item) => ({ ...item, label: masterCarrierLabel(item, locale) }))
}
